import React, { useState } from "react";
import {
  publishSubCategory,
  unPublishSubCategory,
} from "../../../services/subCategoryService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const SubCategoryToggleSwitch = ({ propId, initialStatus, onStatusChange }) => {
  const [isPublished, setisPublished] = useState(initialStatus === "Published");

  const handleToggle = async () => {
    const newStatus = isPublished ? "UnPublish" : "Publish";
    const modalTitle = isPublished
      ? "UnPublish Sub-Category"
      : "Publish Sub-Category";
    const modalMessage = isPublished
      ? "Are you sure you want to unPublish this sub-category?"
      : "Are you sure you want to publish this sub-category?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isPublished) {
          await unPublishSubCategory(propId, newStatus);
        } else {
          await publishSubCategory(propId, newStatus);
        }
        setisPublished(!isPublished);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The sub-category has been ${
            newStatus === "Published" ? "UnPublished" : "Published"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isPublished} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default SubCategoryToggleSwitch;
